<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>

        <total :drunkHistory="getDrunkHistoryToday" :limit="limit"></total>
        <drunk-drinks :drunkHistory="getDrunkHistoryToday" :availableDrinks="availableDrinks" v-on:saveEditDialog="saveEditDialog" v-on:deleteEditDialog="deleteEditDialog" :showLessHistory="showLessHistory"></drunk-drinks>

        <v-flex xs12 class="text-xs-right">
          <!--sdsd-->
          <add-drink v-on:addDrink="addDrink" :defaultDrink="getDefaultDrinkProps"></add-drink>
          <set-default-drink :availableDrinks="getActiveAvailableDrinks" v-on:setDefaultDrink="setDefaultDrink" v-on:addOwnDrink="addOwnDrink" :defaultDrink="getDefaultDrinkProps" v-on:saveEditDrinkTemplate="saveEditDrinkTemplate" v-on:deleteEditDrinkTemplate="deleteEditDrinkTemplate"></set-default-drink>

        </v-flex>
      </v-layout>
    </v-container>
    <div class="signature text-xs-center">
      Aby przebyć tysiąc mil, <br/>trzeba zrobić pierwszy krok.
      <p><router-link v-bind:to="'history'">Przejdź do historii</router-link></p>
    </div>
    <!--<v-bottom-nav absolute :value="true" :active.sync="e1" color="transparent">-->


    <!--<v-btn flat color="teal" value="favorites">-->
    <!--<span>Dodaj</span>-->
    <!--<v-icon>add</v-icon>-->
    <!--</v-btn>-->
    <!--<v-btn flat color="teal" value="recent" v-on:click="showSetDefaultMenu=true">-->
    <!--<span>{{getDefaultDrinkProps.name}}</span>-->
    <!--<v-icon>local_drink</v-icon>-->
    <!--</v-btn>-->
    <!--</v-bottom-nav>-->
  </div>
</template>
<!--</v-flex>-->


<script>
  import localforage from 'localforage';
  import moment from 'moment';
  import total from '@/components/otherComponents/totalBar'
  import setDefaultDrink from '@/components/otherComponents/setDefaultDrink'
  import addDrink from '@/components/otherComponents/addDrink'
  import drunkDrinks from '@/components/otherComponents/drunkDrinks'

  export default {
    name: 'mainView',
    components: {total, setDefaultDrink, addDrink, drunkDrinks},
    data() {
      return {
        // water: 0,
        // myWeight: null,
        settings: null,
        // limit: 0,
        defaultDrink: 1,
        showSetDefaultMenu: false,
        availableDrinks: [
          {
            id: 1,
            name: "Woda",
            size: 200,
            active: true,
          },
        ],
        drunkHistory: [
          {
            id: 1,
            drinkId: 1,
            dateTime: new Date(),
            size: 200,
            active: true,
          }
        ]
      }
    },
    computed: {
      getDefaultDrinkProps() {
        return this.availableDrinks.find((obj) => {
          return obj.id === this.defaultDrink;
        });
      },
      getDrunkHistoryToday: {
        set(val) {
          this.drunkHistory = val;
          // this.createRecord("drunkHistory", this.drunkHistory)
        },
        get() {
          // console.log(this.drunkHistory)
          // if (this.drunkHistory) {
          // return this.drunkHistory.then((value) => {
          return this.drunkHistory.filter(function (key) {
            return moment(key.dateTime).isSame(new Date(), "day");
          })
          // })
          // } else {
          //   return []
          // }
        }

      },
      getActiveAvailableDrinks() {
        return this.availableDrinks.filter(function (key) {
          return key.active !== false;
        })
      },
      getNewIdDrunkHistory() {
        let max = 0;
        this.getDrunkHistoryToday.forEach((el) => {
          if (el.id > max) {
            max = el.id
          }

        });
        return max + 1;
      },
      limit() {
        // set(val) {
        //   localStorage.setItem('limit', JSON.stringify(this.limit));
        // },
        // get() {
        console.log(this.settings)
        if (this.settings !== null) {
          let sum = Math.round(this.settings.myWeight * 0.043 * 1000)
          if (this.settings.sunny) {
            sum += 250;
          }
          if (this.settings.sport) {
            sum += 250;
          }
          return sum
        }
        // }
      },
      showLessHistory() {
        if (this.settings !== null) {

          return this.settings.lessHistory
        } else {
          return false
        }
      }
    },
    created() {
      if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
      // if (localStorage.getItem('sport')) this.sport = JSON.parse(localStorage.getItem('sport'));
      // if (localStorage.getItem('sunny')) this.sunny = JSON.parse(localStorage.getItem('sunny'));

      if (localStorage.getItem('drunkHistory')) this.drunkHistory = JSON.parse(localStorage.getItem('drunkHistory'));
      if (localStorage.getItem('availableDrinks')) this.availableDrinks = JSON.parse(localStorage.getItem('availableDrinks'));
      if (localStorage.getItem('showSetDefaultMenu')) this.showSetDefaultMenu = JSON.parse(localStorage.getItem('showSetDefaultMenu'));
      if (localStorage.getItem('defaultDrink')) this.defaultDrink = JSON.parse(localStorage.getItem('defaultDrink'));
      // if (localStorage.getItem('limit')) this.limit = JSON.parse(localStorage.getItem('limit'));

      // this.setLimit()
    },
    watch: {
      drunkHistory: {
        handler() {
          console.log('drunkHistory changed!');
          localStorage.setItem('drunkHistory', JSON.stringify(this.drunkHistory));
        },
        deep: true,
      },
      availableDrinks: {
        handler() {
          console.log('availableDrinks changed!');
          localStorage.setItem('availableDrinks', JSON.stringify(this.availableDrinks));
        },
        deep: true,
      },
      showSetDefaultMenu: {
        handler() {
          console.log('showSetDefaultMenu changed!');
          localStorage.setItem('showSetDefaultMenu', JSON.stringify(this.showSetDefaultMenu));
        },
        deep: true,
      },
      defaultDrink: {
        handler() {
          console.log('defaultDrink changed!');
          localStorage.setItem('defaultDrink', JSON.stringify(this.defaultDrink));
        },
        deep: true,
      },
      // limit: {
      //   handler() {
      //     console.log('limit changed!');
      //     localStorage.setItem('limit', JSON.stringify(this.limit));
      //   },
      //   deep: true,
      // },
    },
    methods: {
      addDrink() {
        let drinkSize = this.availableDrinks.find((obj) => {
          return obj.id === this.defaultDrink;
        }).size;
        console.log("add drink: ", drinkSize);
        console.log("Drunk history: ", this.drunkHistory)
        console.log("Drunk history length: ", this.drunkHistory.length + 1)
        // this.drunkHistory.push({id: this.getNewIdDrunkHistory, drinkId: this.defaultDrink, dateTime: moment().subtract(10, 'days'), size: drinkSize, active: true})
        this.drunkHistory.push({id: this.getNewIdDrunkHistory, drinkId: this.defaultDrink, dateTime: moment(), size: drinkSize, active: true})
        // this.createRecord("drunkHistory", this.drunkHistory)
      },
      setDefaultDrink(drinkId) {
        console.log("set default drink:", drinkId);
        this.defaultDrink = drinkId;
        this.showSetDefaultMenu = false;
        // this.createRecord("defaultDrink", this.defaultDrink)
      },
      saveEditDrinkTemplate(editedItem) {
        console.log("EDIT ", editedItem)
        // this.availableDrinks = [{}];
        console.log(editedItem.template)
        this.availableDrinks[this.availableDrinks.findIndex(el => el.id === editedItem.id)] = editedItem.template;

        // notify about change! fix save to localStorage ;(
        this.availableDrinks.__ob__.dep.notify()

      },
      deleteEditDrinkTemplate(editedItem) {
        console.log("DELETE ", editedItem)
        // this.availableDrinks = [{}];
        console.log(editedItem.id)
        this.availableDrinks[this.availableDrinks.findIndex(el => el.id === editedItem.id)].active = false;

        // notify about change! fix save to localStorage ;(
        this.availableDrinks.__ob__.dep.notify()

        if (this.getActiveAvailableDrinks.length > 0) {
          this.defaultDrink = this.getActiveAvailableDrinks[0].id || null;
        } else {
          this.defaultDrink = null

        }

      },
      addOwnDrink(properties) {
        console.log("JEST")
        let newDrinkId = this.availableDrinks.length + 1;
        console.log("New drink ID ", newDrinkId)
        this.availableDrinks.push({id: newDrinkId, name: properties.name, size: properties.size, active: true});
        // this.createRecord("availableDrinks", this.availableDrinks)
        this.setDefaultDrink(newDrinkId)
      },
      saveEditDialog(properties) {
        console.log("NEW SIZE: ", properties)
        this.getDrunkHistoryToday.find((obj) => {
          return obj.id == properties.id
        }).size = properties.newSize;
      },
      deleteEditDialog(id) {
        this.getDrunkHistoryToday = this.getDrunkHistoryToday.filter(function (el) {
          return el.id !== id;
        });
        // this.getDrunkHistoryToday.remove((obj)=>{return obj.id == id});
      }

    }
  }
</script>

<style>
  .signature {
    color: #bfbfbf;
  }
</style>



// WEBPACK FOOTER //
// src/components/mainView.vue